import { axiosClient } from "./axiosClient"

export const SUPPLIER_PATH = '/api/v1/supplier'

export const addSupplier = (body) => {
    return axiosClient.post(SUPPLIER_PATH, body)
}

export const updateSupplier = (id, body) => {
    return axiosClient.put(`${SUPPLIER_PATH}/${id}`, body)
}

export const deleteSupplier = (id) => {
    return axiosClient.delete(`${SUPPLIER_PATH}/${id}`)
}

export const getSupplierById = (id) => {
    return axiosClient.get(`${SUPPLIER_PATH}/${id}`)
}

export const getPageSuppliers = ({ search = "", lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${SUPPLIER_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}

export const downloadSupplierReceipt = (id, firstDate, lastDate) => {
    return axiosClient.get(`${SUPPLIER_PATH}/receipt/${id}?firstDate=${firstDate}&lastDate=${lastDate}`, {
        responseType: 'arraybuffer',
    })
}

export const downloadDetailedSupplierReceipt = (id, firstDate, lastDate) => {
    return axiosClient.get(`${SUPPLIER_PATH}/detailed-receipt/${id}?firstDate=${firstDate}&lastDate=${lastDate}`, {
        responseType: 'arraybuffer',
    })
}

export const uploadSupplierExcelFile = (body) => {
    return axiosClient.post(`${SUPPLIER_PATH}/upload-excel`, body)
}

export const downloadSupplierExcelFile = () => {
    return axiosClient.get(`${SUPPLIER_PATH}/download-excel`, {
        responseType: 'arraybuffer',
    })
}

export const downloadSupplierReceipts = (currency) => {
    return axiosClient.get(`${SUPPLIER_PATH}/receipts?currency=${currency}`, {
        responseType: 'arraybuffer',
    })
}
